import _ from 'lodash';

export const offerAdapter = async (offers, coverageLists) => {
  let data = [];
  if (coverageLists.length > 0) {
    _.map(coverageLists, (i) => {
      const getInfo = _.pick(i, [
        'id',
        'uuid',
        'createdAt',
        'partner.name',
        'statusName',
        'value',
        'comment',
        'email',
        'phoneNumber',
        'sale_comment',
        'lastOfferCreatedAt',
        'offerComment',
        'is_accepted',
        'partner_offer',
        'pick_up_confirmed',
        'pick_up_place_confirmed',
      ]);
      getInfo.partnerName = (i.partner.name === 'vpauto' && 'partnerVpauto') || i.partner.name;
      getInfo.is_accepted = i.is_accepted;
      getInfo.sale_comment = i.sale_comment;
      getInfo.value = i.partner_offer?.amount;
      getInfo.lastOfferCreatedAt = i.partner_offer?.created_at;
      getInfo.offerComment = i.partner_offer?.comment;
      getInfo.pickupConfirmed = i.pick_up_confirmed;
      getInfo.pickupPlace = i.pick_up_place_confirmed;
      data = _.uniq(_.concat(data, getInfo));
    });
  }
  if (offers.length > 0) {
    _.map(offers, (i) => {
      const res = {
        id: i.id,
        userId: i.user.id,
        partnerName: `${i.user.first_name} ${i.user.last_name}`,
        createdAt: i.created_at,
        statusName: i.amount > 0 ? 'received' : 'pending',
        value: i.amount,
        comment: '-',
        email: i.user.email ? i.user.email : '-',
        phoneNumber: i.user.phone_number ? i.user.phone_number : '-',
        winner: i.is_winner ? i.user : null,
        saleComment: i.sale.comment ? i.sale.comment : '-',
        lastOfferCreatedAt: i.created_at,
        offerComment: '',
        counter_offer: i.counter_offer ? i.counter_offer : null,
      };
      data = _.uniq(_.concat(data, res));
    });
  }
  if (data.length > 0) {
    data = _.sortBy(data, 'value').reverse();
  }
  return data;
};
